import { newSpecPage } from '@stencil/core/testing'
import { CobaltButton } from '../cobalt-button'

describe('cobalt-button', () => {
  it('should render button element', async () => {
    const page = await newSpecPage({
      components: [CobaltButton],
      html: '<cobalt-button label="Label"></cobalt-button>'
    })
    expect(page.root).toEqualHtml(`
      <cobalt-button label="Label">
        <core-button label="Label" size="medium" type="button" variant="primary"></core-button>
      </cobalt-button>
    `)
  })

  it('should render button element with icon on the left', async () => {
    const page = await newSpecPage({
      components: [CobaltButton],
      html: '<cobalt-button label="Label" label="Label" icon-name="star-solid" icon-position="left"></cobalt-button>'
    })
    expect(page.root).toEqualHtml(`
      <cobalt-button label="Label" label="Label" icon-name="star-solid" icon-position="left">
        <core-button label="Label" size="medium" type="button" variant="primary" icon-name="star-solid" icon-position="left"></core-button>
      </cobalt-button>
    `)
  })

  it('should render button element with icon on the right', async () => {
    const page = await newSpecPage({
      components: [CobaltButton],
      html: '<cobalt-button label="Label" icon-name="star-solid" icon-position="right"></cobalt-button>'
    })
    expect(page.root).toEqualHtml(`
      <cobalt-button label="Label" icon-name="star-solid" icon-position="right">
        <core-button label="Label" size="medium" type="button" variant="primary" icon-name="star-solid" icon-position="right"></core-button>
      </cobalt-button>
    `)
  })
})
